import { render, staticRenderFns } from "./mobile-contact.vue?vue&type=template&id=bf60f6a2&scoped=true"
import script from "./mobile-contact.vue?vue&type=script&lang=js"
export * from "./mobile-contact.vue?vue&type=script&lang=js"
import style0 from "./mobile-contact.vue?vue&type=style&index=0&id=bf60f6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf60f6a2",
  null
  
)

export default component.exports